import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function userLogin(params = { email: email, pwd: pwd }) {
    return post(config.BASE_URL, config.loginUrl, params)
}